exports.AuthModal = require('./authModal');

const FinalizeForm = require('./finalizeForm');

const AuthForm = require('./authForm');

function init() {

  let authForm = document.getElementById("auth-form");
  if (authForm) {
    let form = new AuthForm(window.authOptions);

    authForm.append(form.getElem());
  }

  let finalizeForm = document.getElementById('finalize-form');
  if (finalizeForm) {
    new FinalizeForm(Object.assign({elem: finalizeForm}, window.finalizeOptions || {}));
  }

}

init();
